import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getProviderDetailFetchSuccess,
    getProviderDetailFetchFailure,
    createProviderDetailFetchSuccess,
    createProviderDetailFetchFailure,
    updateProviderDetailFetchSuccess,
    updateProviderDetailFetchFailure,
} from './reducer';
import { ProviderType } from 'src/types/provider';
import translate from '@translate';
import { ProviderDetailResType } from 'src/types/providerDetail';

const getProviderDetailFetchRequest = async (idProvider: string) => {
    const res = await api('get', `api/secure/providers/${idProvider}`);
    return res.data;
};

function* getProviderDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: ProviderDetailResType = yield call((): any => getProviderDetailFetchRequest(action.payload));
        yield put(getProviderDetailFetchSuccess(response));
    } catch (error) {
        yield put(getProviderDetailFetchFailure({ error }));
    }
}

export function* getProviderDetailFetchWatch() {
    yield takeEvery('providerDetail/getProviderDetailFetch', getProviderDetailFetch);
}

const createProviderDetailFetchRequest = async (data: ProviderType) => {
    const res = await api('post', 'api/secure/providers', data);
    return res.data;
};

function* createProviderDetailFetch(action: { type: string; payload: ProviderType }) {
    try {
        const response: ProviderDetailResType = yield call((): any => createProviderDetailFetchRequest(action.payload));
        yield put(
            createProviderDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('providers.message.providerCreated') },
            })
        );
    } catch (error) {
        yield put(createProviderDetailFetchFailure({ error }));
    }
}

export function* createProviderDetailFetchWatch() {
    yield takeEvery('providerDetail/createProviderDetailFetch', createProviderDetailFetch);
}

const updateProviderDetailFetchRequest = async (params: { idProvider: string; data: ProviderType }) => {
    const res = await api('put', `api/secure/providers/${params.idProvider}`, params.data);
    return res.data;
};

function* updateProviderDetailFetch(action: { type: string; payload: { idProvider: string; data: ProviderType } }) {
    try {
        const response: ProviderDetailResType = yield call((): any => updateProviderDetailFetchRequest(action.payload));
        yield put(
            updateProviderDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('providers.message.providerUpdate') },
            })
        );
    } catch (error) {
        yield put(updateProviderDetailFetchFailure({ error }));
    }
}

export function* updateProviderDetailFetchWatch() {
    yield takeEvery('providerDetail/updateProviderDetailFetch', updateProviderDetailFetch);
}
